import { TextValue } from '../_general';

export enum FileCategoryEnum {
    NONE = 0,
    CHROMATOGRAM = 1,
    MISCELLANEOUS_DOCUMENT,
    MUTATION_DIAGRAM,
    ORDER_FILE,
    ORIGINAL_REFERENCE_PAPER,
    PUB_MED_ID,
    SEQUENCE_FILE,
    STRAIN_LITERATURE,
    TYX_SEQUENCING_FORM,
}

export const fileCategoryText: { [key in FileCategoryEnum]: string } = {
    [FileCategoryEnum.NONE]: '',
    [FileCategoryEnum.CHROMATOGRAM]: 'Chromatogram',
    [FileCategoryEnum.MISCELLANEOUS_DOCUMENT]: 'Miscellaneous Document',
    [FileCategoryEnum.MUTATION_DIAGRAM]: 'Mutation Diagram',
    [FileCategoryEnum.ORDER_FILE]: 'Order File',
    [FileCategoryEnum.ORIGINAL_REFERENCE_PAPER]: 'Original Reference Paper',
    [FileCategoryEnum.PUB_MED_ID]: 'PubMed ID',
    [FileCategoryEnum.SEQUENCE_FILE]: 'Sequence File',
    [FileCategoryEnum.STRAIN_LITERATURE]: 'Strain Literature',
    [FileCategoryEnum.TYX_SEQUENCING_FORM]: 'TYX Sequencing Form',
};

export const fileCategories: TextValue[] = [
    { text: fileCategoryText[FileCategoryEnum.NONE], value: FileCategoryEnum.NONE },
    { text: fileCategoryText[FileCategoryEnum.CHROMATOGRAM], value: FileCategoryEnum.CHROMATOGRAM },
    { text: fileCategoryText[FileCategoryEnum.MISCELLANEOUS_DOCUMENT], value: FileCategoryEnum.MISCELLANEOUS_DOCUMENT },
    { text: fileCategoryText[FileCategoryEnum.MUTATION_DIAGRAM], value: FileCategoryEnum.MUTATION_DIAGRAM },
    { text: fileCategoryText[FileCategoryEnum.ORDER_FILE], value: FileCategoryEnum.ORDER_FILE },
    {
        text: fileCategoryText[FileCategoryEnum.ORIGINAL_REFERENCE_PAPER],
        value: FileCategoryEnum.ORIGINAL_REFERENCE_PAPER,
    },
    { text: fileCategoryText[FileCategoryEnum.PUB_MED_ID], value: FileCategoryEnum.PUB_MED_ID },
    { text: fileCategoryText[FileCategoryEnum.SEQUENCE_FILE], value: FileCategoryEnum.SEQUENCE_FILE },
    { text: fileCategoryText[FileCategoryEnum.STRAIN_LITERATURE], value: FileCategoryEnum.STRAIN_LITERATURE },
    { text: fileCategoryText[FileCategoryEnum.TYX_SEQUENCING_FORM], value: FileCategoryEnum.TYX_SEQUENCING_FORM },
];
